// extracted by mini-css-extract-plugin
export default {"login":"login_login__4yZkH","login_left":"login_login_left__fSo-f","login_right":"login_login_right__EvhBf","loginInput":"login_loginInput__4NTO-"};